import { usePayment } from 'client/store'
import typedPaymentSelectors, {
  getOfferBump,
} from 'client/store/payment/paymentSelectors'
import { PricePlan } from 'common/types/OfferInterface'
import { useEffect, useState } from 'react'
import { calculatePrice } from 'src/editor/api/calculate-price'
import {
  CalculatedOfferPrice,
  CalculatePriceRequest,
} from 'src/shared/types/pricing-types'

export const useOfferPricing = () => {
  const offer = usePayment(typedPaymentSelectors.getOffer)
  const product = usePayment(typedPaymentSelectors.getProduct)
  const offerBump = usePayment(getOfferBump)
  const pricePlans: PricePlan[] = offer?.pricePlans || []
  const bumpPricePlans = offerBump?.pricePlans || []
  const bumpProduct = offerBump?.product

  const [calculatedOfferPrice, setCalculatedOfferPrice] =
    useState<CalculatedOfferPrice>([])

  useEffect(() => {
    if (
      !offer?.id ||
      (!product?.id &&
        !pricePlans.length &&
        !bumpProduct?.id &&
        !bumpPricePlans.length)
    ) {
      return
    }

    const controller = new AbortController()

    const fetchPriceData = async () => {
      try {
        const offers: CalculatePriceRequest[] = pricePlans.map(pricePlan => ({
          customer: {},
          quantity: 1,
          offer: offer.id,
          pricePlan: pricePlan.id,
        }))

        if (product?.id) {
          offers.push({
            customer: {},
            product: product.id,
            pricePlan: product.pricePlan.id,
            quantity: 1,
            offer: offer.id,
          })
        }

        bumpPricePlans.forEach(pricePlan => {
          offers.push({
            customer: {},
            quantity: 1,
            offer: offerBump.id,
            pricePlan: pricePlan.id,
          })
        })

        if (bumpProduct?.id) {
          offers.push({
            customer: {},
            product: bumpProduct.id,
            pricePlan: bumpProduct.pricePlan.id,
            quantity: 1,
            offer: offerBump.id,
          })
        }

        if (offers.length === 0) {
          return
        }

        const { data } = await calculatePrice(offers, controller.signal)
        setCalculatedOfferPrice(data)
      } catch (_err) {
        // do nothing
      }
    }

    fetchPriceData()

    return () => {
      controller.abort()
    }
  }, [offer?.id, offerBump?.id])

  const physicalMainOfferPricing = calculatedOfferPrice?.find(
    ({ pricePlan }) => product?.id === pricePlan,
  )

  const digitalOfferPricings = calculatedOfferPrice?.filter(({ pricePlan }) =>
    pricePlans.find(({ id }) => id === pricePlan),
  )

  const physicalBumpOfferPricing = calculatedOfferPrice?.find(
    ({ pricePlan }) => bumpProduct?.id === pricePlan,
  )

  const digitalBumpOfferPricing = calculatedOfferPrice?.find(
    ({ pricePlan }) => bumpPricePlans[0]?.id === pricePlan,
  )

  return {
    physicalMainOfferPricing,
    physicalBumpOfferPricing,
    digitalOfferPricings,
    digitalBumpOfferPricing,
  }
}
